import { useQuery } from 'react-query';
import { FETCH_ALL_RETAILERS } from 'src/backoffice-app-code/libs/reactQuery/configs/reactQueryCashKeys';
import { useDefaultRQConfig } from 'src/backoffice-app-code/libs/reactQuery/hooks/reactQueryBase';
import { getServerErrorMessage } from 'src/backoffice-app-code/utils/errorUtils';
import { RetailerDTO, retailerExtension } from '../../infrastructure/DTOs/RetailerDTO';
import { PartnersRepository } from '../../infrastructure/Repositories/PartnersRepository';

export const useFetchAllRetailers = () => {
  const config = useDefaultRQConfig('useFetchAllRetailers');

  const { isLoading, error, data } = useQuery(
    [FETCH_ALL_RETAILERS],
    () => PartnersRepository.GetAllRetailersAsync(),
    {
      ...config,
      select: (data: RetailerDTO[]) => data.map(retailerExtension),
    }
  );

  return {
    data,
    isLoading,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
  };
};
